import styled from 'styled-components';
import theme from '../../constants/theme';

export const CheckboxSC = styled.div<{ error?: boolean }>`
  display: flex;
  margin-bottom: 16px;

  &.small {
    .checkbox {
      width: 24px;
      height: 24px;
      border-radius: 6px;

      img {
        user-select: none;
        height: 8px;
      }
    }
  }

  label {
    position: relative;
    margin-bottom: 0;
    cursor: pointer;
  }

  input {
    position: absolute;
    opacity: 0;
    cursor: pointer;

    &:checked + .checkbox {
      background-color: ${theme.colors.primary};
      box-shadow: 0 0 10px 1px rgba(106, 213, 229, 0.3);

      img {
        display: block;
      }
    }
  }

  .checkbox {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 40px;
    height: 40px;
    border-radius: 10px;
    background-color: ${({ error }) => (error ? theme.colors.error : theme.colors.inputBg)};

    img {
      display: none;
    }
  }

  .checkbox-text-wrapper {
    align-self: center;
  }

  .checkbox-text {
    flex: 1;
    margin-left: 16px;
    line-height: 1.4;
    font-size: 14px;
    color: ${({ error }) => (error ? theme.colors.error : theme.colors.fontLight)};
    font-weight: 600;

    a {
      color: ${theme.colors.primary};
      font-weight: 700;
    }
  }
`;
